'use client'

import { Divider } from '@/components/ui/divider'
import { TCollectionData } from '@/types/collection'
import { useTranslations } from 'next-intl'
import { useCollectionData } from '../../../hooks/use-collection-data'
import { FilterList } from '../filter-list/filter-list'

type Props = {
  serverData: TCollectionData
  initialFilters?: Record<string, string | string[] | number | undefined>
}

export const FilterGroupDesktop = ({ serverData, initialFilters }: Props) => {
  const t = useTranslations()
  const { data, isLoading } = useCollectionData({ serverData, initialFilters })
  const productCount =
    data?.pages?.[data.pages.length - 1]?.pagination?.total ?? 0

  // Get facets from serverData
  const facets = serverData?.collection_detail?.facets || []
  const card_facets = serverData?.collection_detail?.card_facets || []

  return (
    <div className='sticky top-28 overflow-y-auto lg:max-h-[calc(100vh-100px)] lg:w-[294px] lg:pr-5'>
      <div className='flex items-center justify-between'>
        <p className='font-sans text-base leading-4.5 text-neutral-500'>
          {t('collection_page.title.count_result', {
            count: isLoading ? '...' : productCount || 0,
          })}
        </p>
      </div>
      <Divider className='my-3 mb-0' />
      <FilterList
        facets={facets}
        card_facets={card_facets}
        initialFilters={initialFilters}
      />
    </div>
  )
}
